export default __webpack_public_path__ + "static/media/client1.a0e1de24.svg";